import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// @mui
import { Alert, Stack } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // Import the utc plugin
dayjs.extend(utc); // Extend dayjs with the utc plugin
import api from 'src/api';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { toast } from 'react-toastify';

// ----------------------------------------------------------------------

export default function BidHistoryByGameType({ selectedGame }) {
  const [session, setSession] = useState('');
  const [gameId, setGameID] = useState(selectedGame?.master_game_id || '');
  const dispatch = useDispatch();

  const [masterGameData, setMasterGameData] = useState([]);
  const [gameTypes, setGameTypes] = useState([]);

  const getAllMasterGames = async () => {
    const response = await api.get('/master-games');
    setMasterGameData(response.data.results);
  };

  const getGameTypes = async () => {
    const response = await api.get('/game-types');
    setGameTypes(response.data.results);
  };

  const getAllValues = async () => {
    if(!gameId || !session){
      toast("Please Select Game And Session")
      return
    }
    dispatch(loadingStartAction())
    const response = await api.get(`/dashboard-stats/bid-stats-by-game-session/${gameId}/${session}`);

    let newData = gameTypes.map((item) => {
      let fltArr = response.data?.overallBid.filter((flt) => flt._id === item._id);
      return {
        ...item,
        totalBids: fltArr.length > 0 ? fltArr[0]?.totalBid : 0,
      };
    });
    dispatch(loadingStopAction())

    setGameTypes(newData);
  };

  useEffect(() => {
    getAllMasterGames();
    getGameTypes();
  }, []);

  return (
    <>
      <Stack spacing={3} my={2} direction="row">
        <FormControl
          sx={{
            width: 200,
          }}
        >
          <InputLabel id="demo-simple-select-label">Select Game</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={gameId}
            label="Select Game"
            onChange={(e) => setGameID(e.target.value)}
          >
            {masterGameData?.map((item) => {
              return (
                <MenuItem key={item._id} value={item._id}>
                  {item.game_name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl
          sx={{
            width: 200,
          }}
        >
          <InputLabel id="demo-simple-select-label">Session</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={session}
            label="Session"
            onChange={(e) => setSession(e.target.value)}
          >
            <MenuItem disabled={selectedGame && !selectedGame?.is_open_pending} value={'open'}>
              Open
            </MenuItem>
            <MenuItem disabled={selectedGame && !selectedGame?.is_close_pending} value={'close'}>
              Close
            </MenuItem>
          </Select>
        </FormControl>

        <LoadingButton size="large" type="submit" variant="contained" onClick={getAllValues}>
          Show Info
        </LoadingButton>
      </Stack>

      {gameTypes?.map((item) => {
        return (
          <Alert sx={{ mx: 1, my: 1 }} severity={ item?.totalBids ? "success" :"error"}>
            {item.game_type_name} - {item?.totalBids ? item.totalBids : 0}
          </Alert>
        );
      })}
    </>
  );
}
